import { SelectItem } from "@shared/components";
import { FrontendTemplateModel } from "@shared/models/FrontendTemplate.model";

export const getFrontendChallengeOptions = ({
  frontendTemplates,
  allowedTemplateSeriesCodes,
}: {
  frontendTemplates: FrontendTemplateModel[] | undefined;
  allowedTemplateSeriesCodes: string[] | undefined;
}) => {
  const options =
    frontendTemplates
      ?.map((item) => {
        return {
          label: item.seriesName,
          value: item.seriesCode,
        } as SelectItem;
      })
      .filter((template) => {
        const canUseAnyTemplate = allowedTemplateSeriesCodes?.length === 0;

        return (
          canUseAnyTemplate ||
          allowedTemplateSeriesCodes?.includes(template.value as string)
        );
      }) ?? [];

  return options;
};
